import React, { useContext, createContext, useState } from 'react';
import { PropTypes } from 'prop-types';

const initialState = {
  isOpen: false,
  subjectId: 'Não Encontrado',
  pat_id: 'Não Encontrado',
  pat_name: 'Não Encontrado',
  consentType: 'Não Encontrado',
};

const RemoveConsentModalContext = createContext(initialState);

export function RemoveConsentModalContextProvider({ children }) {
  const [removeConsentModalState, setRemoveConsentModalState] =
    useState(initialState);

  return (
    <RemoveConsentModalContext.Provider
      value={{ removeConsentModalState, setRemoveConsentModalState }}
    >
      {children}
    </RemoveConsentModalContext.Provider>
  );
}

export function useRemoveConsentModalContext() {
  return useContext(RemoveConsentModalContext);
}

RemoveConsentModalContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
